import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _31127d8d = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _b7a07358 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _cf236a24 = () => interopDefault(import('../pages/tnc/index.vue' /* webpackChunkName: "pages/tnc/index" */))
const _7d551de2 = () => interopDefault(import('../pages/auth/register-success.vue' /* webpackChunkName: "pages/auth/register-success" */))
const _8fd966e6 = () => interopDefault(import('../pages/auth/registration-status.vue' /* webpackChunkName: "pages/auth/registration-status" */))
const _ce93f88a = () => interopDefault(import('../pages/auth/status.vue' /* webpackChunkName: "pages/auth/status" */))
const _25d842c0 = () => interopDefault(import('../pages/error/expired.vue' /* webpackChunkName: "pages/error/expired" */))
const _420597b4 = () => interopDefault(import('../pages/faq/doctor.vue' /* webpackChunkName: "pages/faq/doctor" */))
const _4c163e6a = () => interopDefault(import('../pages/klinik/signIn.vue' /* webpackChunkName: "pages/klinik/signIn" */))
const _567c758d = () => interopDefault(import('../pages/register/doctor.vue' /* webpackChunkName: "pages/register/doctor" */))
const _f7153362 = () => interopDefault(import('../pages/register/dokter.vue' /* webpackChunkName: "pages/register/dokter" */))
const _4ad2c39c = () => interopDefault(import('../pages/register/psycholog.vue' /* webpackChunkName: "pages/register/psycholog" */))
const _df20a05c = () => interopDefault(import('../pages/rs/signIn.vue' /* webpackChunkName: "pages/rs/signIn" */))
const _67ddc636 = () => interopDefault(import('../pages/sp/signIn.vue' /* webpackChunkName: "pages/sp/signIn" */))
const _763ee954 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/privacy",
    component: _31127d8d,
    name: "privacy___id"
  }, {
    path: "/register",
    component: _b7a07358,
    name: "register___id"
  }, {
    path: "/tnc",
    component: _cf236a24,
    name: "tnc___id"
  }, {
    path: "/auth/register-success",
    component: _7d551de2,
    name: "auth-register-success___id"
  }, {
    path: "/auth/registration-status",
    component: _8fd966e6,
    name: "auth-registration-status___id"
  }, {
    path: "/auth/status",
    component: _ce93f88a,
    name: "auth-status___id"
  }, {
    path: "/error/expired",
    component: _25d842c0,
    name: "error-expired___id"
  }, {
    path: "/faq/doctor",
    component: _420597b4,
    name: "faq-doctor___id"
  }, {
    path: "/klinik/signIn",
    component: _4c163e6a,
    name: "klinik-signIn___id"
  }, {
    path: "/register/doctor",
    component: _567c758d,
    name: "register-doctor___id"
  }, {
    path: "/register/dokter",
    component: _f7153362,
    name: "register-dokter___id"
  }, {
    path: "/register/psycholog",
    component: _4ad2c39c,
    name: "register-psycholog___id"
  }, {
    path: "/rs/signIn",
    component: _df20a05c,
    name: "rs-signIn___id"
  }, {
    path: "/sp/signIn",
    component: _67ddc636,
    name: "sp-signIn___id"
  }, {
    path: "/",
    component: _763ee954,
    name: "index___id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
